'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultStyle = exports.defaultStyle = {
  minWidth: '150px',
  textAlign: 'center',
  margin: 0,
  padding: 0,
  border: 'none',
  backgroundColor: 'inherit',
  '& .progressIndicator': {
    height: '.75em'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle() {
  return {
    // backgroundColor: disabled ? theme.colors.disabled : theme.colors.primary
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/StepButton/StepButton.style.js
// module id = 627
// module chunks = 0